<template>
  <div class="menu view container-fluid bottom-nav-spacing large-text"
       style="margin-left: -15px;margin-right: -15px; padding-left: 30px;padding-right: 30px; max-height: calc(100vh - 100px)">

    <div class="row bg-light-blue ">
      <div class="col-xs-12 spacer-top spacer-bottom">
        {{ _('Rechtliches') }}
      </div>
    </div>
    <div class="row menu-item-row">
      <div class="col-xs-12 spacer-y">
        <a :href="_('https://hensel-recycling.com/impressum/')" target="_blank" rel="noreferrer">{{ _('Impressum') }}
          <i class="fas fa-chevron-right"></i>
        </a>
      </div>
    </div>
    <div class="row menu-item-row">
      <div class="col-xs-12 spacer-y">
        <a :href="_('https://hensel-recycling.com/datenschutz/')" target="_blank" rel="noreferrer">{{ _('Datenschutz') }}
          <i class="fas fa-chevron-right"></i>
        </a>
      </div>
    </div>
    <div class="row menu-item-row">
      <div class="col-xs-12 spacer-y">
        <a :href="_('https://hensel-recycling.com/downloads/')" target="_blank" rel="noreferrer">{{ _('AGB') }}
          <i class="fas fa-chevron-right"></i>
        </a>
      </div>
    </div>
    <div class="row bg-light-blue ">
      <div class="col-xs-12 spacer-top spacer-bottom">
        {{ _('Profil') }}
      </div>
    </div>
    <div class="row menu-item-row">
      <div class="col-xs-12 spacer-y">
        <table width="100%">
          <tr>
            <td style="vertical-align: top">
              {{ _("Name:") }}&nbsp;&nbsp;&nbsp;&nbsp;
            </td>
            <td style="vertical-align: top; text-align: right">
              {{ user ? user.name : '' }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row menu-item-row">
      <div class="col-xs-12 spacer-y">
        <table width="100%">
          <tr>
            <td style="vertical-align: top">
              {{ _("Sprache:") }}&nbsp;&nbsp;&nbsp;&nbsp;
            </td>
            <td style="vertical-align: top; text-align: right">
              <select name="language"
                      class="color-blue"
                      @change="updateLocalizations"
                      style="margin: 0 !important;">
                <option v-for="l in languages" :value="l" :key="l" :selected="l === lang">
                  {{ _(l) }}
                </option>
              </select>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row menu-item-row">
      <div class="col-xs-12 spacer-y">
        <table v-if="user" width="100%">
          <tr>
            <td style="vertical-align: top; width: 33%">
              {{ _("E-Mail:") }}&nbsp;&nbsp;&nbsp;&nbsp;
            </td>
            <td style="vertical-align: top; text-align: right">
              {{ user.email }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 spacer-y text-center text-danger" style="cursor: pointer" @click="tryLogout">
        <template v-if="user">{{ user.name }}</template>
        {{ _('abmelden') }}
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 spacer-y text-center">
        <button type="button" class="btn-danger btn" @click.prevent="tryDelete">
          {{ _('Benutzerkonto löschen') }}
        </button>
      </div>
    </div>
    <div class="row" style="padding-top: 1em">
      <div class="col-xs-12 text-center small">
        KATalog mobile<br>
        Version: {{ appVersion }}<br>
        Device ID: {{ deviceID }}
      </div>
    </div>
  </div>
</template>
<script>
//Vuex
import {mapActions, mapState} from 'vuex'

export default {
  name: "Menu",
  data() {
    return {
      deviceID: ""
    }
  },
  computed: {
    ...mapState({
      user: state => state.Api.Users.current,
      lang: state => state.Api.Localizations.language,
      languages: state => state.Api.Localizations.all,
      appVersion: state => state.appVersion,
    }),
  },
  methods: {
    ...mapActions({
      logout: 'Api/Users/logout',
      deleteAccount: 'Api/Users/deleteAccount',
      fetchLocalizations: 'Api/Localizations/get',
    }),
    updateLocalizations(e) {
      this.fetchLocalizations({language: e.target.value})
          .then(() => {
            this.$localforage.setItem(process.env.VUE_APP_LANGUAGE_STORE_KEY, e.target.value)
                .catch(e => null)
          })
          .catch(this.apiErrorHandler)
    },
    async tryLogout() {
      try {
        await this.logout()

        sessionStorage.clear()

        await this.$localforage.clear()

        window.location.reload()
      } catch (err) {
        this.apiErrorHandler(err)
      }
    },
    async tryDelete() {
      console.log('tryDelete')

      try {
        if (confirm(this._('Benutzerkonto wirklich löschen?'))) {
          await this.deleteAccount()

          await this.tryLogout()
        }
      } catch (err) {
        this.apiErrorHandler(err)
      }
    }
  },
  created() {
    this.$localforage.getItem('deviceUUID')
        .then(deviceId => this.deviceID = deviceId)
        .catch(e => null)
  },
  mounted () {
    if (!this.user) {
      this.$router.push({ name: 'Login' })
      return;
    }
  },
}
</script>

<style lang="scss">
@import "../styles/variables";

.menu {
  .menu-item-row {
    border-bottom: 1px solid $light;

    a {
      color: $dark;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-decoration: none;

      &:focus {
        text-decoration: none;
        outline: none;
      }
    }
  }
}

</style>

